import { validarSesion } from "./Auth";
const config = require("../env.json")

export const obtenerAsistenciaMesAno=async(Asistencia,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/asistencia/`+Asistencia.ActividadId+`/`+Asistencia.Ano+`/`+Asistencia.Mes;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const actualizarAsistenciaMesAno=async(asistencia,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/asistencia`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"PUT",
            body:JSON.stringify(asistencia)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const obtenerActividadesAsistidas=async(mesAno,token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/asistenciaregistros/`+mesAno.Ano+`/`+mesAno.Mes;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;

}
